import React, {Component} from 'react';
import {Divider, Table} from "@material-ui/core";
import TableHeaderList from "./TableHeaderList";
import TableBodyList from "./TableBodyList";
import TableFooterList from "./TableFooterList";
import TableToolbarList from "./TableToolbarList";
import ListHoc from "../../../../../HocHelpers/ListHoc";
import Loading from "../../../../../Utils/Loading/Loading";

class TableList extends Component {
    constructor(props) {
        super(props);
        this.mySearchRef = React.createRef();
        this.state = {};
    }
    render() {
        const {hideListFooter, layoutType, hideColumnHeader, hideListHeader, applyAdvancedFilter, listName,  loading} = this.props;
        let toolBar = document.getElementById(`listToolBar_${listName}`);
        let toolBarHeight = hideListHeader ? 0 : 37;
        if (toolBar) {
            let positionInfo = toolBar.getBoundingClientRect();
            toolBarHeight = positionInfo.height;
        }
        let heightDescent = toolBarHeight + 41;
        let heightWrapper = !hideListFooter ? `calc(99% - ${heightDescent}px)` : ('auto');
        return (
            <React.Fragment>
                <TableToolbarList applyAdvancedFilter={applyAdvancedFilter} mySearchRef={this.mySearchRef}/>
                <Divider/>
                <div className={'tableWrapper'} style={{height: heightWrapper}}>
                    <div id={`tableWrapper_${listName}`}
                         style={{width: '100%', overflowX: 'auto', maxHeight: '100%', height: '100%'}}>
                        {loading && <Loading/>}
                        <Table stickyHeader size={"small"} id={`listTable_${listName}`} style={{tableLayout: layoutType}}>
                            {(hideColumnHeader === false || hideColumnHeader === undefined) && (
                                <TableHeaderList/>
                            )}
                            <TableBodyList/>
                        </Table>
                    </div>
                </div>
                {!hideListFooter && (
                    <TableFooterList/>
                )}
            </React.Fragment>
        );
    }
}

export default ListHoc(TableList);